import React, { FunctionComponent, useState, useEffect, useCallback } from "react";
import { Button, Checkbox, TextArea, Icon, Badge, Loader, Modal } from "@scuf/common";
import { updateOpportunity } from "../../../slices/opportunitySlice";
import { ERROR_MSG_FOR_USER_RESPONSE, HAS_SCRIPT, ACTION_UPLOAD_TYPE, CHECKLIST_UPLOAD_TYPE, RouteConstants, USER_ROLE } from "../../../constants/constants";
import { useAppDispatch } from "../../../store";
import { getReasons, getUploadedFiles } from "../../../services/Opportunities";
import { IUserResponseModel } from "../../../models/IOpportunitiesAPIModel";
import { FileUpload } from "../../UploadFileModal/FileUpload";
import { useNavigate } from "react-router-dom";
import "./AcceptPopup.scss";
import { useSelector } from 'react-redux';
import { getCurrentRole } from 'src/slices/onBoardingSlice';
import { tagEvent, TAG_EVENT_CONST } from "src/utils/analytics/analytics.service.util";
import { getMessage } from "src/message/utils";
import DOMPurify from 'dompurify';
import { AttachmentDownload } from "./AttachmentDownload";

interface IRejectPopup {
  onClose: Function;
  insightId: any;
  kpiId: number;
  title: string;
  textAreaTitle: string;
  opportunityId: any;
  activityDetails: any;
  opportunityCategory: string;
  insightSummaryDisplayCategory?: string;
  closeAction?: Function;
  role_name?: string;
}


// Anomaly reject popup
export const RejectPopup: FunctionComponent<IRejectPopup> = (props) => {
  const navigate = useNavigate();

  const [enableRetryErr, setEnableRetryErr] = useState(false); // flag to enable submit button
  const [rejectActionInProgress, setRejectActionInProgress] = useState(false);
  const [btnText, setBtnText] = useState("Submit");
  const [remark, setRemark] = useState("");
  const [reviewerRemark, setReviewerRemark] = useState("");
  const [showLableBardge, setShowLableBardge] = useState(false);
  const [submitBtnDisable, setSubmitBtnDisable] = useState(true);
  const dispatch = useAppDispatch();
  const [rejectCheckReason, setRejectCheckReason] = useState([] as any);
  const [selctedPolicy, setselctedPolicy] = useState([] as any); // flag to enable submit button
  const [selctedDesStatus, setselctedDesStatus] = useState([]); // flag to enable submit button
  const [refresh, setRefresh] = useState(false);
  const [reasonLoading, setReasonLoading] = useState(true);
  const [reasonError, setReasonError] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showRemarkError, setShowRemarkError] = useState(false);
  const [rejecetedFlag, setRejectedFlag] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const isOrgOwnerUI5 = props.role_name === USER_ROLE.ORG_USER &&
    props.insightSummaryDisplayCategory === "UI 5";
  const [hasRequiredEvidence, setHasRequiredEvidence] = useState(false);
  const [fileUploadedData, setFileUploadedData] = useState([] as any);
  const reviewerFiles = fileUploadedData?.activity?.filter((file: { type: string; file_details?: { file_name?: string } }) =>
    file.type === CHECKLIST_UPLOAD_TYPE &&
    typeof file.file_details?.file_name === "string" &&
    file.file_details.file_name.trim().length > 0
  ) || [];
  const currentRole = useSelector(getCurrentRole);
  const warningText = getMessage('app.notes.footer.warning');


  const categoryPo = /^PO\sSplit*/;
  const remarkHandleChange = (e: string) => {
    setRemark(e.trimStart());
    compareActions(e);
    if (e.trimStart() === "") {
      let result = selctedDesStatus.filter((item) => item === true);
      if (result.length == 0) {
        setSubmitBtnDisable(false);
        setRefresh(!refresh);
      }
      if (result.length > 0) {
        setSubmitBtnDisable(true);
        setRefresh(!refresh);
      }
    }

    if (e.trimStart() === "" && rejectCheckReason.length === 0) {
      setSubmitBtnDisable(true);
    } else if (e.trimStart() !== "" && rejectCheckReason.length === 0) {
      setSubmitBtnDisable(false);
    }
    if (rejectCheckReason.length > 0) {
      if (selctedPolicy.length === 0) {
        setSubmitBtnDisable(true);
        setRefresh(!refresh);
      }
    }
  };
  useEffect(() => {
    setReasonLoading(true);
    setReasonError(false);
    getReasons(props.opportunityId, "reject")
      .then((response) => {
        setReasonLoading(false);
        setRejectCheckReason(response);
      })
      .catch(() => {
        setReasonError(true);
        setReasonLoading(false);
      });
  }, []);

  const loadUploadedFiles = useCallback(() => {
    getUploadedFiles(props.opportunityId)
      .then((response: any) => {
        const activity = Array.isArray(response.activity) ? response.activity : [];
        setFileUploadedData({ activity });
        if (!isOrgOwnerUI5) {
          return;
        }
        const hasFile = activity.some((item: any) =>
          item.type === ACTION_UPLOAD_TYPE &&
          typeof item.file_details?.file_name === "string" &&
          item.file_details.file_name.trim().length > 0
        );
        setHasRequiredEvidence(hasFile);
      })
      .catch(() => {
        setFileUploadedData({ activity: [] });
        if (isOrgOwnerUI5) {
          setHasRequiredEvidence(false);
        }
      });
  }, [isOrgOwnerUI5, props.opportunityId]);

  useEffect(() => {
    loadUploadedFiles();
  }, [loadUploadedFiles]);

  useEffect(() => {
    if (
      props.activityDetails != undefined &&
      props.activityDetails.length > 0
    ) {
      if (props.activityDetails[0].action_details.user_response == "reject") {
        const reviewerRemark = props.activityDetails[0].action_details.remarks;
        setReviewerRemark(reviewerRemark);
        const reasons = props.activityDetails[0].action_details.reason;
        let reasonArray = reasons.split(",");
        setselctedPolicy(reasonArray);
        if (rejectCheckReason.length > 0) {
          rejectCheckReason.forEach((element: any) => {
            element.checked = false;
          });
          reasonArray.map((reasonValue: string) => {
            let objIndex = rejectCheckReason.findIndex(
              (obj: any) => obj.title == reasonValue
            );
            if (objIndex >= 0) {
              rejectCheckReason[objIndex].checked = true;
            }
          });
          let checkedArray = rejectCheckReason.filter(
            (data: any) => data.checked == true
          );
          setRejectCheckReason(rejectCheckReason);
          let requireRemarkArray: any = [];
          for (let i = 0; i < checkedArray.length; i++) {
            requireRemarkArray.push(checkedArray[i].requires_remarks);
          }
          setselctedDesStatus(requireRemarkArray);
          setRefresh(!refresh);
          setReasonLoading(false);
          compareActions(remark);
        }
        compareActions(reviewerRemark);
      }
    }
  }, [rejectCheckReason.length]);

  const handleCheckbox = (
    id: number,
    check: boolean,
    name: string,
    Des: boolean
  ) => {
    if (check === true) {
      selctedPolicy.splice(selctedPolicy.indexOf(name), 1); // @ts-ignore
      selctedDesStatus.splice(selctedDesStatus.indexOf(Des), 1);
    } else {
      selctedPolicy.push(name); // @ts-ignore
      selctedDesStatus.push(Des);
    }
    let showBardge = selctedDesStatus.filter((item) => item === true);
    compareActions(remark);

    if (showBardge.length >= 1) {
      if (remark.length == 0) {
        setShowLableBardge(true);
        setSubmitBtnDisable(true);
      } else {
        setShowLableBardge(false);
        setSubmitBtnDisable(false);
      }
    } else if (selctedDesStatus.length === 0) {
      setSubmitBtnDisable(true);
      setShowLableBardge(false);
    } else {
      setShowLableBardge(false);
      setSubmitBtnDisable(false);
    }
    let newState = rejectCheckReason.map((item: any) =>
      item.reason_id === id ? { ...item, checked: check ? false : true } : item
    );
    setRejectCheckReason(newState);
  };


  const compareActions = (newremark: string): boolean => {
    if (
      props.activityDetails != undefined &&
      props.activityDetails.length > 0
    ) {
      if (props.activityDetails[0].action_details.user_response == "reject") {
        const reasons = props.activityDetails[0].action_details.reason;
        let reasonArray = reasons.split(",");
        const reviewerRemark = props.activityDetails[0].action_details.remarks;
        if (reasonArray.length == selctedPolicy.length) {
          const data = reasonArray.filter((res: string) =>
            selctedPolicy.includes(res)
          );
          if (
            data.length == selctedPolicy.length &&
            newremark === reviewerRemark
          ) {
            setBtnText("Assign Action");
            setSubmitBtnDisable(false);
            return false;
          }
        }
        if (reasons.length === 0 && newremark === reviewerRemark) {
          setBtnText("Assign Action");
          setSubmitBtnDisable(false);
          return false;
        }
      }
    }
    setBtnText("Submit");
    setSubmitBtnDisable(false);
    return true;
  };
  const submitRejectAction = () => {
    if (isOrgOwnerUI5 && !hasRequiredEvidence) {
      return;
    }
    const feedback = selctedPolicy.toString();
    setRejectActionInProgress(true);
    setEnableRetryErr(false);
    setBtnText("Submitting...");
    let inValidCharacter = /[<>()&#]/;
    let data: IUserResponseModel = {
      current_role: currentRole,
      user_response: "reject",
      reason: feedback,
      remarks: remark,
      kpi_id: props.kpiId,
    };
    if (btnText === "Assign Action" && props.role_name === "insight.org_user") {
      data = {
        current_role: currentRole,
        user_response: "reject",
        reason: feedback,
        remarks: remark,
        kpi_id: props.kpiId,
        accept_as_is: true,
      };
    } else if (props.role_name === "insight.org_user") {
      data = {
        current_role: currentRole,
        user_response: "reject",
        reason: feedback,
        remarks: remark,
        kpi_id: props.kpiId,
        accept_as_is: false,
      };
    }
    if (!inValidCharacter.test(remark)) {
      setRejectedFlag(true);
      dispatch(updateOpportunity(props.opportunityId, data))
        .then(() => {
          tagEvent(TAG_EVENT_CONST.review, { AnomalyId: props.insightId, RejectCount: 'EventCount' });
          setRejectActionInProgress(false);
          setBtnText("Submit");
          navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH);
          props.onClose();
        })
        .catch(() => {
          setRejectActionInProgress(false);
          setEnableRetryErr(true);
          setBtnText("Retry");
        });
    } else {
      setShowRemarkError(true);
      setBtnText("Submit");
      setRejectActionInProgress(false);
    }
  };
  return (
    <>
      <Modal.Header className="reject-header">
        {categoryPo.test(props.opportunityCategory) &&
          <>{props.title}</>
        }
      </Modal.Header>
      <Modal.Content className="reject-content">
        <div>
          <div style={{ position: "relative" }} data-testid="getInvoiceCard">
            {reasonLoading && (
              <Loader
                loading={reasonLoading}
                text="Fetching reasons..."
                minHeight="28vh"
                max-height="70vh"
                overlayColor="transparent"
              />
            )}
            {reasonError && (
              <div className="action--error-text">
                {ERROR_MSG_FOR_USER_RESPONSE}
              </div>
            )}
            {rejectCheckReason &&
              rejectCheckReason.map((item: any, index: any) => (
                <Checkbox
                  key={item.reason_id}
                  className="checkbox-fi"
                  data-testid={`cb-reason1${index}`}
                  label={
                    item.desc !== null
                      ? `${item.title} ${item.desc}`
                      : `${item.title}`
                  }
                  checked={item.checked}
                  onChange={() => {
                    handleCheckbox(
                      item.reason_id,
                      item.checked,
                      item.title,
                      item.requires_remarks
                    );
                  }}
                />
              ))}
          </div>
        </div>
        {categoryPo.test(props.opportunityCategory) ? (
          <label className="label">
            Remarks{" "}
            {showLableBardge && remark === "" ? (
              <Badge empty={true} color="red" />
            ) : (
              ""
            )}
          </label>
        ) : (
          <label className="label">
            Remarks <Badge empty={true} color="red" />
          </label>
        )}
        <TextArea
          onChange={remarkHandleChange}
          className="textarea-wrapper textarea-fi accept-gap"
          fluid={true}
          rows={2}
          placeholder={props.textAreaTitle}
          value={remark.trimStart()}
        />
        {showRemarkError && (
          <div className="reject-popup__remarkerr">{HAS_SCRIPT}</div>
        )}
        {props.role_name === USER_ROLE.ORG_USER && <>
          <label className="label">
            Reviewer's Remarks:{" "} <i> {reviewerRemark}</i>

          </label>
          {reviewerFiles.length > 0 && (
            <section aria-label="Reviewer uploaded files">
              <div className="accept-popup__uploadfiles accept-popup__uploadfiles--reviewer">Files Uploaded by Reviewer</div>
              <div className="file-value-wrapper old-files-wrapper">
                {reviewerFiles.map((file: { file_details: { file_name: string; stored_file_name?: string } }, index: number) => (
                  <span className="file-value-wrapper-content" key={`${index}-${file.file_details.file_name}`}>
                    <Icon name="document-report" root="common" size="small" className="file-value-icon" />
                    <div className="file-value-wrapper-content-data">{file.file_details.file_name}</div>
                    <AttachmentDownload opportunityId={props.opportunityId} fileName={file.file_details.file_name} storedFileName={file.file_details.stored_file_name} />
                  </span>
                ))}
              </div>
            </section>
          )}
        </>
        }
        <div className="accept-popup__uploadfiles">
            Upload Files
            {isOrgOwnerUI5 && !hasRequiredEvidence && (
              <span className="upload-required-indicator" role="img" aria-label="Supporting file required">
                <Badge empty={true} color="red" />
              </span>
            )}
          </div>
        {isUploaded && <div className="reject-popup__remarkerr">Please upload the file before submiting</div>}
        <div className="upload-wrapper_reasons">
          <FileUpload
            className="document-upload" // @ts-ignore
            anomaly_id={props.opportunityObjectName}
            opportunityId={props.opportunityId}
            type={ACTION_UPLOAD_TYPE}
            updateUploadedStatus={(uploaded: boolean) => setIsUploaded(uploaded)}
            onUploadSuccess={loadUploadedFiles}
          />
        </div>
        {fileUploadedData?.activity?.length > 0 && (
          <div className="file-value-wrapper old-files-wrapper">
            {fileUploadedData.activity
              .filter((file: any) =>
                file.type === ACTION_UPLOAD_TYPE &&
                typeof file.file_details?.file_name === "string" &&
                file.file_details.file_name.trim().length > 0
              )
              .map((file: any, index: number) => (
                <span
                  className="file-value-wrapper-content"
                  key={`${index}-${file.file_details.file_name}`}
                >
                  <Icon
                    name="document-report"
                    root="common"
                    size="small"
                    className="file-value-icon"
                  />
                  <div className="file-value-wrapper-content-data">
                    {` ${file.file_details.file_name}`}
                  </div>
                  <AttachmentDownload opportunityId={props.opportunityId} fileName={file.file_details.file_name} storedFileName={file.file_details.stored_file_name} />
                </span>
              ))}
          </div>
        )}
      </Modal.Content>
      <Modal.Footer className="reject-popup__footer pop-footer">
        {enableRetryErr && (
          <div className="reject-popup__footer--err err-msg">
            {ERROR_MSG_FOR_USER_RESPONSE}
          </div>
        )}
        <Button
          className="button--secondary button-space"
          data-testid="cancel"
          size="small"
          type="secondary"
          disabled={rejectActionInProgress}
          onClick={() => {
            props.onClose();
          }}
          content="Cancel"
        />
        <Button
          className={`button--primary ${rejectActionInProgress
            ? "reject-popup__footer--readonly btn-loading"
            : ""
            } button-space`}
          icon={
            enableRetryErr ? (
              <Icon
                root="building"
                name="refresh"
                exactSize={22}
                className="reject-popup__footer--retry"
              />
            ) : (
              ""
            )
          }
          iconPosition="right"
          size="small"
          disabled={submitBtnDisable || isUploaded || (isOrgOwnerUI5 && !hasRequiredEvidence) ? true : false}
          type="primary"
          data-testid="submit"
          onClick={submitRejectAction}
          content={btnText}
        />
      </Modal.Footer>
    </>
  );
};
